import React from "react";
import dynamic from "next/dynamic";
const UseCasesCard = dynamic(() => import("./UseCasesCard"),{ssr: true});
const UseCasesSliderMobile = dynamic(() => import("./UseCasesSliderMobile"),{ssr: true});

interface UseCasesSliderProps {
  data?: Array<{
    short_title: string;
    title: string;
    image: {
      url: string;
    };
    link: {
      href: string;
      label: string;
    };
  }>;
  isMobile?: boolean;
}

const UseCasesSlider: React.FC< UseCasesSliderProps> = ({ data,
  isMobile,
 }) => {
  const baseUrl = process.env.NEXT_PUBLIC_REACT_APP_RESOURCE_BASE_URL ?? "";

  // Map backend data to component props
  const useCasesData =
    data?.map((item: any) => ({
      title: item?.title || "",
      description: item?.short_title,
      imageUrl: item?.image
        ? `${baseUrl}${item?.image?.data?.attributes?.url}`
        : "/images/ServicesInner/ai-service_usecases02.jpg",
      buttonLabel: item?.link?.label,
      buttonLink: item?.link?.href,
    })) || [];

  return (
    <>
      {!isMobile && (
        <div className="mt-10">
          <div className="container grid grid-cols-3 gap-[30px]">
            {useCasesData?.map((item, index) => (
              <UseCasesCard
                key={index}
                title={item?.title}
                description={item?.description}
                imageUrl={item?.imageUrl}
                buttonLabel={item?.buttonLabel}
                buttonLink={item?.buttonLink}
              />
            ))}
          </div>
        </div>
      )}

      {isMobile && <UseCasesSliderMobile data={useCasesData} />}
    </>
  );
};
export default UseCasesSlider;